import { render, staticRenderFns } from "./Faturamento.vue?vue&type=template&id=6c96887e"
import script from "./Faturamento.vue?vue&type=script&lang=ts"
export * from "./Faturamento.vue?vue&type=script&lang=ts"
import style0 from "./Faturamento.vue?vue&type=style&index=0&id=6c96887e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports